<template>
  <div>
    <!-- header-->
    <div class="carousel-header-container">
      <!-- carousel title -->
      <div class="carousel-label">
        <span v-if="title">
          {{ title }}
        </span>
      </div>

      <!-- nav container -->
      <div
        v-if="totalPage > 1"
        class="nav-wrapper"
      >
        <!-- left -->
        <button
          class="nav-button"
          @click.stop="scrollLeftHandler"
        >
          <img
            src="@/assets/icons/icon_arrow-left.svg"
            alt=""
            class="nav-icon"
          >
        </button>

        <!-- right -->
        <button
          class="nav-button"
          @click.stop="scrollRightHandler"
        >
          <img
            src="@/assets/icons/icon_arrow-right.svg"
            alt=""
            class="nav-icon">
        </button>
      </div>
    </div>

    <!-- body -->
    <div
      class="carousel-body-container"
      @mouseenter="stopAutoSlide"
      @mouseleave="startAutoSlide"
    >
      <div
        ref="carouselWrapperRef"
        class="carousel-body-wrapper"
      >
        <slot></slot>
      </div>
    </div>

    <!-- footer -->
    <div class="carousel-footer-container">
      <label
        v-for="page in totalPage"
        :key="page"
      >
        <input
          v-model="currentIndex"
          type="radio"
          :name="`carousel-${carouselId}`"
          :value="page - 1"
          @change="updateScroll"
        />
        <span class="page-bar"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    autoplay: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number || String,
      default: 5
    },
    title: {
      type: String,
      default: ''
    },
    itemsPerPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      currentIndex: 0,
      totalPage: 0,
      pageWidth: 0,
      intervalId: null,
      carouselId: this._uid
    }
  },
  mounted () {
    const el = this.$refs.carouselWrapperRef
    const containerWidth = el.getBoundingClientRect().width
    const contentWidth = el.children[0].getBoundingClientRect().width
    const gap = (this.itemsPerPage > 1)
      ? (containerWidth - (contentWidth * this.itemsPerPage)) / (this.itemsPerPage - 1)
      : 0

    this.pageWidth = (containerWidth + gap)
    this.totalPage = Math.ceil(el.children.length / this.itemsPerPage)

    el.style.gap = `${gap}px`

    this.startAutoSlide()
  },
  methods: {
    updateScroll () {
      const container = this.$refs.carouselWrapperRef.parentElement
      const targetCardIndex = (this.currentIndex * this.itemsPerPage)
      const targetCard = this.$refs.carouselWrapperRef.children[targetCardIndex]

      if (targetCard && container) {
        const scrollAmount = (this.currentIndex * this.pageWidth)

        container.scrollTo({
          left: scrollAmount,
          behavior: 'smooth'
        })
      }
    },
    scrollLeftHandler () {
      this.currentIndex -= 1
      if (this.currentIndex < 0) {
        this.currentIndex = (this.totalPage - 1)
      }

      this.updateScroll()
      this.startAutoSlide()
    },
    scrollRightHandler () {
      this.currentIndex += 1

      if (this.currentIndex === this.totalPage) {
        this.currentIndex = 0
      }

      this.updateScroll()
      this.startAutoSlide()
    },
    startAutoSlide () {
      this.stopAutoSlide()

      if ((this.autoplay) && (this.totalPage > 0)) {
        const duration = (Number(this.duration) * 1000)

        this.intervalId = setInterval(() => {
          this.scrollRightHandler()
        }, duration)
      }
    },
    stopAutoSlide () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    }
  }
}
</script>

<style scoped>
.carousel-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.carousel-header-container .carousel-label {
  font-size: 24px;
  line-height: 40px;
  color: #202020;
}

.nav-wrapper {
  display: flex;
  justify-self: end;
  gap: 10px;
}

.nav-button {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid #DCDCDC;
  border-radius: 50%;
  background-color: #0000000D;
  cursor: pointer;
}

.nav-button:hover {
  background-color: #0000001A;
  border-color: #AAAAAA;
  transform: scale(1.05);
  transition: all 0.2s ease;
}

.nav-button:active {
  background-color: #00000026;
  transform: scale(0.95);
}

.nav-button .nav-icon {
  width: 18px;
  height: 18px;
  filter: brightness(0.5);
}

.carousel-body-container {
  width: 100%;
  overflow: hidden;
  scroll-snap-type: x mandatory;
}

.carousel-body-wrapper {
  display: flex;
  transition: all 0.8s ease;
}

.carousel-body-wrapper > * {
  scroll-snap-align: start;
  flex-shrink: 0;
}

.carousel-footer-container {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 32px;
}

.carousel-footer-container input {
  display: none;
}

.page-bar {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50px;
  background: #ccc;
  transition: all 0.5s ease;
  cursor: pointer;
}

input:checked + .page-bar {
  width: 12px;
  background: #666666BF;
}
</style>
